module.exports = __webpack_public_path__ + "static/media/amex.d29f1cc3.png";